import { useState, useCallback } from 'react';

const useNotificationBar = () => {
  const [params, setParams] = useState({});

  const setNotificationBar = useCallback(
    ({ show, duration = 10000, ...props }) => {
      setParams({ show, duration, ...props });
    },
    [setParams]
  );

  return { setNotificationBar, params };
};

export default useNotificationBar;
